/** Typed confirmation matches only when the expected value is non-empty. */
export function typedConfirmMatches(typed: string, expected: string): boolean {
  const target = expected || '';
  return target.length > 0 && typed.trim() === target;
}
